import React from 'react';
import { FileTextIcon, UploadCloudIcon, XIcon } from 'lucide-react';
import type { CalculatorStepProps, ClaimType } from '../../types/claimCalculator';
interface ClaimDocumentsStepProps extends CalculatorStepProps {
  claimType: ClaimType;
  files: File[];
  fileError: string;
  onFilesAdded: (files: FileList | null) => void;
  onFileRemoved: (index: number) => void;
}
export function ClaimDocumentsStep({
  claimType,
  data,
  update,
  files,
  fileError,
  onFilesAdded,
  onFileRemoved
}: ClaimDocumentsStepProps) {
  return <div className="space-y-4" data-id="element-25" data-mp="1vj17j81iacry">
      <p className="text-small font-semibold text-ink" data-id="element-26" data-mp="1vi9d40jnal39">Documents and other details</p>
      <label className="block text-[12px] font-semibold text-slate" data-id="element-27" data-mp="20df6tljah41w">
        Other details/questions
        <textarea value={data.otherDetails} onChange={event => update('otherDetails', event.target.value)} rows={3} className="mt-1 w-full rounded-input border border-ink/15 bg-canvas px-3.5 py-3 text-[13px] text-ink outline-none focus:border-forest focus:ring-2 focus:ring-signal/30" data-id="element-28" data-mp="25chzs7lzvjti" />
      </label>

      {claimType !== 'road' && <div data-id="element-29" data-mp="3n93jy2a52wz">
          <p className="text-[13px] font-semibold text-ink" data-id="element-30" data-mp="3qn4r2z7j62u">
            Attach a claim form or other documents
            <span className="font-normal text-slate" data-id="element-31" data-mp="3pvquwr6s2rja"> (optional)</span>
          </p>
          <label className="mt-2 flex cursor-pointer flex-col items-center justify-center rounded-input border border-dashed border-forest/35 bg-canvas px-4 py-5 text-center hover:border-forest focus-within:ring-2 focus-within:ring-signal/30" data-id="element-32" data-mp="3pxvaw7hybgzx">
            <UploadCloudIcon className="h-6 w-6 text-forest" aria-hidden="true" data-id="element-33" data-mp="hnjxj9yvyxmd" />
            <span className="mt-2 text-[13px] font-semibold text-forest" data-id="element-34" data-mp="cpibqha2sk77">Choose documents</span>
            <span className="mt-1 text-[11px] text-slate" data-id="element-35" data-mp="1a4crgtc0poax">PDF, Word, JPG or PNG · 10 MB each</span>
            <input type="file" multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" className="sr-only" onChange={event => {
          onFilesAdded(event.target.files);
          event.target.value = '';
        }} data-id="element-36" data-mp="15e65704zafvu" />
          </label>
          {fileError && <p role="alert" className="mt-2 text-[12px] font-medium text-signal" data-id="element-37" data-mp="2pv5gagpzwc0m">{fileError}</p>}
          {files.length > 0 && <ul className="mt-2 space-y-2" data-id="element-38" data-mp="2usowvna610vq">
              {files.map((file, index) => <li key={`${file.name}-${file.lastModified}`} className="flex items-center gap-2 rounded-input bg-warm-tint px-3 py-2 text-[12px] text-ink" data-id="element-39" data-mp="2fzvglzn2kgq0" data-mpi={index}>
                  <FileTextIcon className="h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-40" data-mp="26y4d91g04lzb" />
                  <span className="min-w-0 flex-1 truncate" data-id="element-41" data-mp="2bve0qbjtynki">{file.name}</span>
                  <button type="button" onClick={() => onFileRemoved(index)} className="rounded p-1 text-slate hover:text-signal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" aria-label={`Remove ${file.name}`} data-id="element-42" data-mp="55zdx4w6amek">
                    <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="k9iz7jtjobqv" />
                  </button>
                </li>)}
            </ul>}
        </div>}
    </div>;
}